






















































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
@Component({
    name: "AwardCard",
})
export default class AwardCard extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    showawrad: boolean = false;
    handleScroll(event: any) {
        let d: any = document;
        let scrollpos = window.scrollY;
        const elem = d.querySelector('.awardcard-container');
        const counterlist = (window.scrollY + window.innerHeight);
        const isHalfshown = counterlist > elem.offsetTop;
        const countbottom = elem.offsetTop + elem.height;
        const isNotscrolledPast = window.scrollY < countbottom;
        if (isHalfshown) {
            (this as any).showawrad = true;
        }

    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
